export const DEBOUNCE_WAIT = 500;
export const SEARCH_MODAL_PARAM_KEY = 'search';
